import {
    ResultObj,
    allFetch,
} from "../Domain";
import { valueIsValid } from "../api";

/** 搜尋職責 (參數)
 * @description 搜尋職責 (參數)
 * @param {string} code 代碼
 * @param {string} name 名稱
 * @param {string} is_calculate_salary 是否計薪
 * @param {string} ul_id 職務編號
 * @param {string} page 頁碼
 * @param {string} num_per_page 一頁幾筆
 */
export interface UserDutySearchParams {
    code?: string;
    name?: string;
    is_calculate_salary?: string;
    ul_id?: string;
    page?: number;
    num_per_page?: number;
}

/**@description 搜尋職責 (回傳) */
export interface UserDutySearchResItem {
    C: number;
    code: string;
    is_calculate_salary: string;
    name: string;
    ud_id: number;
    ul_id: number;
    ul_name: string;
}

/** @description 搜尋職責 */
export const UserDutySearch = async (
    obj: UserDutySearchParams
): Promise<ResultObj<UserDutySearchResItem[]>> => {
    return await allFetch('UserDuty/UserDutySearch', obj);
};


/** 職責檢查是否存在 (參數)
 * @description 職責檢查是否存在 (參數)
 * @param {string} code 代碼
 */
export interface UserDutyExistParams {
    code: string;
}

/** @description 職責檢查是否存在 */
export const UserDutyExist = async (
    obj: UserDutyExistParams
): Promise<ResultObj> => {
    return await allFetch('UserDuty/UserDutyExist', obj);
};


/** 新建職責 (參數)
 * @description 新建職責 (參數)
 * @param {string} code 代碼
 * @param {string} name 名稱
 * @param {string} is_calculate_salary 是否計薪
 * @param {string} ul_id 職務編號
 */
export interface UserDutyCreateParams {
    code: string;
    name: string;
    is_calculate_salary: string;
    ul_id: string;
}

/** @description 新建職責 */
export const UserDutyCreate = async (
    obj: UserDutyCreateParams
): Promise<ResultObj> => {
    return await allFetch('UserDuty/UserDutyCreate', obj);
};

/** 職責細項 (參數)
 * @description 職責細項 (參數)
 * @param {string} ud_id 職責編號
 */
export interface UserDutyDetailParams {
    ud_id: string;
}

export interface UserDutyDetailResItem {
    info: {
        code: string;
        is_calculate_salary: "Y" | "N" | '';
        name: string;
        ud_id: number;
        ul_id: number | -1;
    }[],
    pageControl: { pc_id: string }[],
    pages: { page_id: string }[]

}

/** @description 職責細項 */
export const UserDutyDetail = async (
    obj: UserDutyDetailParams
): Promise<ResultObj<UserDutyDetailResItem>> => {
    return await allFetch('UserDuty/UserDutyDetail', obj);
};

/** 修改職責 (參數)
 * @description 修改職責 (參數)
 * @param {string} ud_id 職責編號
 * @param {string} code 代碼
 * @param {string} name 名稱
 * @param {string} is_calculate_salary 是否計薪
 * @param {string} ul_id 職務編號
 */
export interface UserDutyUpdateParams {
    ud_id: string;
    code: string;
    name: string;
    is_calculate_salary: string;
    ul_id: string;
}

/** @description 修改職責 */
export const UserDutyUpdate = async (
    obj: UserDutyUpdateParams
): Promise<ResultObj> => {
    return await allFetch('UserDuty/UserDutyUpdate', obj);
};


/** 更新職責對應權限 (參數)
 * @description 更新職責對應權限 (參數)
 * @param {string} ud_id 職責編號
 * @param {string} permission_list 權限代碼
 */
export interface UserDutyUpdatePermissionParams {
    ud_id: string;
    permission_list: permission_list[]
}

/** @description 更新職責對應權限 */
export const UserDutyUpdatePermission = async (
    obj: UserDutyUpdatePermissionParams
): Promise<ResultObj> => {
    return await allFetch('UserDuty/UserDutyUpdatePermission', obj);
};



/** 權限代碼 (參數)
 * @description 權限代碼 (參數)
 * @param {string} pg_id 頁面群組編號
 * @param {string} page_id 頁面編號
 * @param {string} pc_id 頁面控制項編號
 */
export interface permission_list {
    pg_id: string,
    page_id: string,
    pc_id: string
}


/** 查詢使用者擁有的職責 (參數)
 * @description 查詢使用者擁有的職責 (參數)
 * @param {string} user_id 帳號編號 
 * @param {string} page 頁碼
 * @param {string} num_per_page 一頁幾筆
 */
export interface UserOwnDutySearchParams {
    user_id: string;
    page: number;
    num_per_page: number;
}

export interface UserOwnDutySearchResItem {
    ud_id: number;
    code: string;
    name: string;
    is_calculate_salary: string;
    source_user_id: string;
    isneed: string;
}

/** @description 查詢使用者擁有的職責 */
export const UserOwnDutySearch = async (
    obj: UserOwnDutySearchParams
): Promise<ResultObj<UserOwnDutySearchResItem[]>> => {
    return await allFetch('UserDuty/UserOwnDutySearch', obj);
};